
export default {
  name: 'BlogAuthorBriefSection',
  props: {
    mode: {
      type: String,
      default: "horizontal"
    },
    name: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    authorCode: {
      type: String,
      default: ""
    },
    image: {
      type: Object,
      default: ()=> {}
    }
  },
  data() {
    return {
      activeItem: "lifestageoffering-1",
      modeAvailable: ["horizontal", "vertical"]
    }
  },
  computed: {
  },
  methods: {
  },
}
